import { Instance, applySnapshot, flow, getParent, types } from 'mobx-state-tree';

import { deleteGradeType, getGradeType, saveGradeType } from '@common/api/gradeTypes';

import { IGradeTypesModel } from './GradeTypes';

const GradeType = types
	.model('GradeType', {
		id: types.identifierNumber,
		name: types.optional(types.string, ''),
		subject_id: types.maybeNull(types.number),
		is_include_topic: types.maybeNull(types.boolean),
		is_published: types.optional(types.union(types.number, types.boolean, types.null), 0),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		get parent(): IGradeTypesModel {
			const parent = getParent<IGradeTypesModel>(self, 2);

			return parent;
		},
	}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getGradeType(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield saveGradeType(self.id, data);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		remove: flow(function* () {
			self.loading = true;
			try {
				yield deleteGradeType(self.id);
				self.parent.removeItem(self);
			} catch (e) {
				self.loading = false;
			}
		}),
	}));

export default GradeType;

export interface IGradeTypeModel extends Instance<typeof GradeType> {}
